import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { LogoLockup } from "./Logo";
import { CONTACT } from "../lib/site";

export const Footer = () => (
  <footer className="bg-navy-dark text-white">
    <div className="h-px gold-rule opacity-60" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="inline-block rounded-2xl bg-white px-5 py-4">
            <LogoLockup className="w-52" />
          </div>
          <p className="mt-5 font-serif italic text-lg text-white/70">Making the invisible visible.</p>
        </div>
        <nav aria-label="Footer">
          <p className="font-sans text-xs font-semibold tracking-[0.22em] uppercase text-gold mb-5">Explore</p>
          <ul className="space-y-3">
            <li>
              <Link to="/" data-testid="footer-link-home"
                className="font-sans text-sm text-white/75 hover:text-gold transition-colors duration-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-link-contact"
                className="font-sans text-sm text-white/75 hover:text-gold transition-colors duration-300">
                Contact
              </Link>
            </li>
          </ul>
        </nav>
        <div>
          <p className="font-sans text-xs font-semibold tracking-[0.22em] uppercase text-gold mb-5">Talk With Us</p>
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email-link"
            className="flex items-center gap-3 font-sans text-sm text-white/75 hover:text-gold transition-colors duration-300 break-all"
          >
            <Mail className="w-4 h-4 shrink-0 text-gold" /> {CONTACT.email}
          </a>
          <a
            href={CONTACT.phoneHref}
            data-testid="footer-phone-link"
            className="mt-4 flex items-center gap-3 font-sans text-sm text-white/75 hover:text-gold transition-colors duration-300"
          >
            <Phone className="w-4 h-4 shrink-0 text-gold" /> {CONTACT.phone}
          </a>
        </div>
      </div>
      <div className="mt-14 pt-7 border-t border-white/10">
        <p className="font-sans text-xs text-white/50">© 2026 Foresight Global Systems. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
